export const getMethodApprovedFromSearch = (
    search = window.location.search,
): 'email' | 'sms' | undefined => {
  const deliveryMethod = new URLSearchParams(search).get('deliveryMethod');
  return deliveryMethod === 'email' || deliveryMethod === 'sms' ?
      deliveryMethod :
      undefined;
};
